import { useLazyQuery } from '@apollo/client';
import { exportXlsModal } from 'motion-components';
import { gqlGetQuery } from '../graphql';
import { buildWhereFromFilterValues } from './filters';
import { useState } from 'react';
import { format, parseISO } from 'date-fns';

export const exportColumns = (t) => {
  return [
    // { fieldName: "id", fieldTitle: "Id", fieldType: "TEXT" },
    { fieldName: 'id', fieldTitle: t('ID'), fieldType: 'TEXT' },
    { fieldName: 'plateNumber', fieldTitle: t('Αριθμός Κυκλοφορίας Οχήματος'), fieldType: 'TEXT' },
    { fieldName: 'collector.name', fieldTitle: t('Συλλέκτης'), fieldType: 'TEXT' },
    { fieldName: 'grossWeight', fieldTitle: t('Μικτό Φορτίο'), fieldType: 'TEXT' },
    { fieldName: 'payloadWeight', fieldTitle: t('Οφέλιμο Φορτίο'), fieldType: 'TEXT' },
    { fieldName: 'isActive', fieldTitle: t('Ενεργή Εγγραφή'), fieldType: 'TEXT' },
    { fieldName: 'firstRec', fieldTitle: t('Δήλωση'), fieldType: 'TEXT' },
    { fieldName: 'lastRec', fieldTitle: t('Αλλαγή'), fieldType: 'TEXT' },
  ];
};

export async function handleExport(client, queryState: any, t): Promise<void> {
  function useGetQuery() {
    const [get, { loading }] = useLazyQuery(gqlGetQuery, { onCompleted: transformData });
    const [result, setResult] = useState<any>([get, { loading, data: undefined }]);
    function transformData(data) {
      const recs = data.getVehicles.data.map((values) => {
        return {
          ...values,
          isActive: !values.isActive ? t('ΟΧΙ') : t('ΝΑΙ'),
          firstRec: ` ${
            values.firstDate ? format(parseISO(values.firstDate), 'dd/MM/yy HH:mm') : ''
          }  - ${values.firstUser}`,
          lastRec: ` ${
            values.lastDate ? format(parseISO(values.lastDate), 'dd/MM/yy HH:mm') : ''
          }  - ${values.lastUser}`,
        };
      });
      const trsData = {
        getVehicles: { data: recs, recordCount: data?.getVehicles?.recordCount },
      };
      setResult([get, { loading, data: trsData }]);
    }
    return result;
  }

  const filterVariables = {
    where: buildWhereFromFilterValues(queryState?.filterValues),
  };

  await exportXlsModal({
    apolloClient: client,
    exportFileName: 'export Vehicles',
    getLazyQuery: useGetQuery,
    columnsDef: exportColumns(t),
    filterVariables: filterVariables,
  });
}
